import { Page } from '@/components/layout/page/page.tsx'
import { Separator } from '@/components/ui/separator.tsx'

export const ExpiringFansPageSkeleton = () => {
  return (
    <Page>
      <div className="flex flex-col">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <div className="md:flex-1 ">
            <div className="h-[32px] w-full max-w-[250px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton">
              &nbsp;
            </div>
            <div className="mt-1  h-[20px] w-full max-w-[500px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton">
              &nbsp;
            </div>
          </div>
          <div className="flex gap-2">
            <div className="h-[20px] w-[55px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton">
              &nbsp;
            </div>
            <div className="h-[20px] w-[45px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton">
              &nbsp;
            </div>
          </div>
        </div>

        <Separator className="my-8 animate-pulse" />
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between ">
          <div className="h-[32px] w-[204px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton">
            &nbsp;
          </div>
          <div className="flex gap-2">
            <div className="h-[42px] w-[214px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton md:ml-auto">
              &nbsp;
            </div>
            <div className="h-[42px] w-[214px] flex-shrink-0 animate-pulse rounded-lg bg-skeleton md:ml-auto">
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}
